export const HEX_RADIUS = 0.55;
export const HEX_HEIGHT = 0.12;
export const HEX_TILE_SCALE = 0.88;
export const HEX_TILE_DIAMETER = HEX_RADIUS * 2 * HEX_TILE_SCALE;
